import React, { useEffect, useState } from "react";
import { getFileFromS3 } from "../../../../pages/Requirement/services/RequirementServices";

const AsyncImage = ({ imageKey, alt = "", width = "50px", height = "40px" }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [hasLoaded, setHasLoaded] = useState(false);
  const defaultImage = "/images/default.jpg"; // Path to default image

  useEffect(() => {
    const fetchImage = async () => {
      if (imageKey) {
        try {
          const url = await getFileFromS3(imageKey);
          setImageUrl(url || defaultImage); // Use default if url is falsy
        } catch (err) {
          console.warn("Image not found or failed to load:", imageKey);
          setImageUrl(defaultImage); // Set default image on error
        } finally {
          setHasLoaded(true);
        }
      } else {
        setImageUrl(defaultImage); // Set default if no imageKey
        setHasLoaded(true);
      }
    };

    fetchImage();
  }, [imageKey]);

  // Only show image if it exists
  if (!hasLoaded || !imageUrl) return <span></span>;

  return (
    <img
      src={imageUrl}
      alt={alt}
      style={{ width, height, objectFit: "cover" }}
    />
  );
};

export default AsyncImage;